import { call, all, put, takeEvery } from 'redux-saga/effects';
import {
  getManageSkillsSuccessAction,
  getManageSkillsFailureAction,
  getManageSkillAction,
  setSaveSkillsSuccessAction,
  setSaveSkillsFailureAction,
  deleteManageSkillsSuccessAction,
  deleteManageSkillsFailureAction,
  
  getManageSkillUpdateSuccessAction,
  getManageSkillUpdateFailureAction

 
} from '../../features/ManageSkills/ManageSkillsSlice';
import URLs from '../../../constants/urls';
import { GET_MANAGE_SKILL,SET_MANAGE_SKILL,DELETE_MANAGE_SKILL, GET_MANAGE_SKILLSDATA} from '../../actions/ManageSkills/ManageSkillsActionType';
import { apiPython as api } from '../../../service/api';

export function* getmanagSkillCyclesSaga() {                    
  try {
    console.log("called");
    const response = yield api.get(URLs.GET_MANAGE_SKILL);

    const envelope = response?.data;
    const inner = envelope?.data ?? envelope?.Data;
    const rawList = Array.isArray(inner) ? inner : inner?.$values;
    const safeRawData = Array.isArray(rawList) ? rawList : [];

    const dataArray = safeRawData
      .filter(item => item && typeof item === 'object' && (item.Id !== undefined || item.id !== undefined))
      .map(item => ({
        id: item.Id ?? item.id,
        skillName: item.SkillName ?? item.skillName ?? '',
        parentSkill_Id: item.ParentSkill_Id ?? item.parentSkill_Id ?? item.parentSkillId ?? null,
        isActive: item.IsActive ?? item.isActive ?? false
      }));

    yield put(getManageSkillsSuccessAction(dataArray));
  } catch (error) {
    console.log(error, "err");
    yield put(getManageSkillsFailureAction(error?.response?.data?.message || 'Could not fetch skills'));
  }
}

export function* setSaveSkillsSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_MANAGE_SKILL, body);
    yield put(setSaveSkillsSuccessAction(response.data));
    yield call(getmanagSkillCyclesSaga);
  } catch (error) {
    yield put(setSaveSkillsFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Could not save'));
  }
}

export function* deleteManageSkillSaga({ payload: id }) {
  const formData = new FormData();
  formData.append('Id', id);
  try {
    const response = yield api.post(URLs.DELETE_MANAGE_SKILL, formData);
    yield put(deleteManageSkillsSuccessAction(response.data));
    
    yield call(getmanagSkillCyclesSaga);
  } catch (error) {
    yield put(deleteManageSkillsFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Could not delete'));
  }
}

export function* getmanageSkillsUpdateSaga({ payload: id }) {
  try {
    yield api.get(`${URLs.GET_MANAGE_SKILLSDATA}?id=${id}`);
    yield put(getManageSkillUpdateSuccessAction());
  } catch (error) {
    yield put(getManageSkillUpdateFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Fetch failed'));
  }
}



export function* watchmanageSkills() {
  yield takeEvery(GET_MANAGE_SKILL, getmanagSkillCyclesSaga);
  yield takeEvery(SET_MANAGE_SKILL, setSaveSkillsSaga);
  yield takeEvery(DELETE_MANAGE_SKILL, deleteManageSkillSaga);
  yield takeEvery(GET_MANAGE_SKILLSDATA,getmanageSkillsUpdateSaga);
}

export default function* manageSkillsSaga() {
  yield all([watchmanageSkills()]);
}


